import './Footer.css';
import React from 'react';
import zomato from '../../utils/images/zomato.png';
import { BsInstagram, BsTwitter } from 'react-icons/bs';
import { ImLinkedin2 } from 'react-icons/im';
import { TfiFacebook } from 'react-icons/tfi';
import { TbBrandGithub } from 'react-icons/tb';

const Footer = () => {
    return (
        <div className='footer-container'>
            <div className='footer'>
                <a href='/'><img id='logo' src={zomato} alt="Zomato" loading='lazy' /></a>

                <div className='copyright'>
                    2023 © Zomato Clone™<br />
                    created by <a href='https://www.linkedin.com/in/suhan-kulal-96096a182/' target='_blank' id='creator'>Suhan</a>
                </div>
                <div className='social-media'>
                    <a href='https://www.linkedin.com/in/suhan-kulal-96096a182/' target='_blank'><ImLinkedin2 /></a>
                    <a href='https://github.com/suhan1234/' target='_blank'><TbBrandGithub /></a>
                    <a href='#' target='_blank'><BsTwitter /></a>
                    <a href='https://www.instagram.com/suhan_996_?igsh=OGQ5ZDc2ODk2ZA== ' target='_blank'><BsInstagram /></a>
                    <a href='https://github.com/suhan1234/' target='_blank'><TfiFacebook /></a>
                </div>
            </div>
        </div>
    )
}

export default Footer;
